import { BodyPage, ControlsFilters, TabMenus } from './components';
import { LayoutPage } from '@/components/hoc';
import { Separator } from '@/components/ui';
import { Undo2 } from 'lucide-react';

const VerificationsHistoryPage = () => (
	<LayoutPage
		header={{
			description: `Consulter l'historique de verifications effectuées par les utilisateurs.`,
			title: 'Historique'
		}}
		breadcrumb={{ title: 'Historique' }}
		icon={Undo2}>
		<div className='flex flex-col space-y-3 '>
			<TabMenus />
			<Separator className='bg-muted' />
			<ControlsFilters />
			<BodyPage />
		</div>
	</LayoutPage>
);

export default VerificationsHistoryPage;
